(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EventCategoryTypeSearch', EventCategoryTypeSearch);

    EventCategoryTypeSearch.$inject = ['$resource'];

    function EventCategoryTypeSearch($resource) {
        var resourceUrl =  'api/_search/event-category-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
